import React from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'
import { Submitting } from '../common/Submitting'

const getHighlightedText = (text, highlight) => {
  const highlightParts = highlight.split(' ')
  const parts = text.split(' ')

  return (
    <span>
      {parts &&
        parts.map((part, i) => (
          <span
            key={i}
            style={
              highlightParts &&
              highlightParts.some(
                highlight =>
                  highlight &&
                  part
                    .replace(/[^a-z0-9]/gi, '')
                    .toLowerCase()
                    .indexOf(
                      highlight.toLowerCase().replace(/[^a-z0-9]/gi, '')
                    ) > -1
              )
                ? { fontWeight: 'bold' }
                : {}
            }
          >
            {`${part} `}
          </span>
        ))}
    </span>
  )
}

class LocationSearchBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = { address: '' }
  }

  handleChange = address => {
    this.setState({ address })
  }

  handleSelect = address => {
    this.setState({ address })
    this.props.updateAddress(address)
  }

  render() {
    const {
      address,
      search,
      submitting,
      redirectOverride,
      showError
    } = this.props
    return (
      <section>
        <div className="row">
          <div className="col-xs">
            <label>Search for an address</label>
            <PlacesAutocomplete
              highlightFirstSuggestion
              value={this.state.address}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
              onEnterKeyDown={search}
              onError={() => {}}
            >
              {({ getInputProps, getSuggestionItemProps, suggestions }) => {
                const className = suggestions.length
                  ? 'autocomplete-dropdown-container autocomplete-dropdown-container__active'
                  : 'autocomplete-dropdown-container'
                return (
                  <div className="autocomplete-root">
                    <input
                      {...getInputProps({
                        placeholder: 'Enter an address',
                        autoFocus: true
                      })}
                      tabIndex="6"
                    />
                    <div className={className}>
                      {suggestions.map(suggestion => {
                        const className = suggestion.active
                          ? 'autocomplete-suggestion autocomplete-suggestion__active'
                          : 'autocomplete-suggestion'

                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className
                            })}
                          >
                            <span>
                              {getHighlightedText(
                                suggestion.description,
                                getInputProps().value
                              )}
                            </span>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              }}
            </PlacesAutocomplete>
            {showError ? (
              <span className="error">Sorry, that's not a valid location.</span>
            ) : null}
          </div>
        </div>
        <div className="row center-xs">
          <div className="col-xs-12">
            {submitting ? (
              <Submitting />
            ) : (
              <button
                type="submit"
                tabIndex="7"
                disabled={!address || !address.trim()}
                className="locationsearch-button"
                onClick={() => search(address, !redirectOverride)}
              >
                <i className="icon-location" /> Search
              </button>
            )}
          </div>
        </div>
      </section>
    )
  }
}

export default LocationSearchBox
